/* eslint-disable */
import { createMaintenanceWork } from '@/requests/techInspection'
import {
  showErrorMessage,
  showSuccessMessage
} from '@/utils/createMessage'
import moment from 'moment'
import Api from '@/repository/index'
// import Route from '@/router'
import router from '@/core/utils/router'
const TOGGLE_LOADING = 'TOGGLE_LOADING'
const TOGGLE_LOADING_TYPES = 'TOGGLE_LOADING_TYPES'
const SET_MAINTENANCE_WORK = 'SET_MAINTENANCE_WORK'
const ADD_MAINTENANCE_WORK = 'ADD_MAINTENANCE_WORK'
const REMOVE_MAINTENANCE_WORK = 'REMOVE_MAINTENANCE_WORK'
const UPDATE_MAINTENANCE_WORK = 'UPDATE_MAINTENANCE_WORK'
const SET_MAINTENANCE_TYPES = 'SET_MAINTENANCE_TYPES'
const SET_MAINTENANCE_HISTORY = 'SET_MAINTENANCE_HISTORY'
const ADD_MAINTENANCE_HISTORY = 'ADD_MAINTENANCE_HISTORY'
const SET_FILTERS = 'SET_FILTERS'
const SET_REPAIR_WORKS = 'SET_REPAIR_WORKS'
const state = {
  isLoading: true,
  isLoadingTypes: true,
  // isLoadingMaintenanceRequestFalse: true,
  // isLoadingMaintenanceRequestTrue: true,
  maintenanceWork: [],
  maintenanceTypes: [],
  maintenanceHistory: [],
  repairWorks: [],
  filters: {
    stateNumber: '',
    serviceTypeId: '',
    sortiong: null
  }
}
export const helpers = {
  getCurrentOnReq () {
    const getCurrentRouter = router?.currentRoute.name
    if (getCurrentRouter === 'techInspection.repairs') return true
    return false
  }
}
const mutations = {
  [TOGGLE_LOADING] (state, bool) {
    state.isLoading = bool
  },
  [SET_REPAIR_WORKS] (state, data) {
    state.repairWorks = data
  },
  [TOGGLE_LOADING_TYPES] (state, bool) {
    state.isLoadingTypes = bool
  },
  // [TOGGLE_LOADING_MAINTENANCE_TRUE] (state, bool) {
  //   state.isLoadingMaintenanceRequestTrue = bool
  // },
  // [TOGGLE_LOADING_MAINTENANCE_FALSE] (state, bool) {
  //   state.isLoadingMaintenanceRequestFalse = bool
  // },
  [SET_MAINTENANCE_WORK] (state, data) {
    state.maintenanceWork = data
  },

  [ADD_MAINTENANCE_WORK] (state, item) {
    state.maintenanceWork.push(item)
  },

  [SET_MAINTENANCE_TYPES] (state, array) {
    state.maintenanceTypes = array
  },

  [UPDATE_MAINTENANCE_WORK] (state, item) {
    const index = state.maintenanceWork.findIndex(e => e.id === item.id)
    state.maintenanceWork.splice(index, 1, item)
  },

  [REMOVE_MAINTENANCE_WORK] (state, id) {
    const index = state.maintenanceWork.findIndex(e => e.id === id)
    state.maintenanceWork.splice(index, 1)
  },

  [SET_MAINTENANCE_HISTORY] (state, array) {
    state.maintenanceHistory = array
  },

  [ADD_MAINTENANCE_HISTORY] (state, item) {
    state.maintenanceHistory.push(item)
  },

  [SET_FILTERS] (state, filters) {
    state.filters = filters
  }
}
const actions = {
  async fromActual (_, id) {
    try {
      await Api.maintenance.index.fromActual(id)
    } catch (err) {
      showErrorMessage('Не удалось обновить актуальность')
      return Promise.reject(err)
    }
  },
  async fetchRepairWorks ({ commit }) {
    try {
      const response = await Api.repairWorks.getRepairWorks()
      commit(SET_REPAIR_WORKS, response)
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },

  async createRepairWorks ({ commit, dispatch }, data) {
    try {
      await Api.repairWorks.createRepairWorks(data)
      await dispatch('fetchRepairWorks')
      showSuccessMessage('Успешно!')
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },

  async createRepairPrice ({ commit }, data) {
    try {
      await Api.repairWorks.createRepairPrice({ maintenanceRepairPrice: data })
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },

  async createRepairPrices ({ commit }, array) {
    try {
      await Api.repairWorks.createRepairPrices({ maintenanceRepairPrices: array })
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },

  async updateRepairPrice ({ commit }, { id, data }) {
    try {
      await Api.repairWorks.updateRepairPrice(id, data)
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },

  async updateRepairPrices ({ commit }, array) {
    try {
      await Api.repairWorks.updateRepairPrices({ maintenanceRepairPrices: array })
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },

  async deleteRepairPrice ({ commit, dispatch }, id) {
    try {
      console.log(id)
      await Api.repairWorks.deleteRepairPrice(id)
      showSuccessMessage('Успешно!')
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    }
  },
  async deleteRepairWorks ({ commit, dispatch }, id) {
    try {
      await Api.repairWorks.deleteRepairWorkById(id)
      await dispatch('fetchRepairWorks')
      showSuccessMessage('Успешно!')
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },
  async updateRepairWorks ({ commit, dispatch }, { id, data }) {
    try {
      await Api.repairWorks.updateRepairWorks(id, data)
      await dispatch('fetchRepairWorks')
      showSuccessMessage('Успешно!')
    } catch (err) {
      showErrorMessage('Не удалось загрузить')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },
  async fetchMaintenanceTypes ({ commit }) {
    try {
      commit(TOGGLE_LOADING_TYPES, true)
      const response = await Api.maintenance.index.getMaintenanceTypes()
      commit(SET_MAINTENANCE_TYPES, response)
    } catch (err) {
      showErrorMessage('Не удалось загрузить типы ремонта')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING_TYPES, false)
    }
  },

  async fetchMaintenanceWorkHistory ({ commit }) {
    try {
      commit(TOGGLE_LOADING, true)

      const response = await Api.maintenance.index.getMaintenanceHistory()
      console.log(response)
      commit(SET_MAINTENANCE_HISTORY, response)
    } catch (err) {
      showErrorMessage('Не удалось загрузить историю ремонта')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async fetchMaintenanceHistoryById ({ commit }, car_id) {
    if (!car_id) return

    try {
      return await Api.maintenance.index.getMaintenanceHistoryByCarId(car_id)
    } catch (err) {
      showErrorMessage()
      return Promise.reject(err)
    }
  },

  async fetchMaintenanceWork ({ commit }, { on_request }) {
    try {
      commit(TOGGLE_LOADING, true)
      const response = await Api.maintenance.index.getMaintenances({ filterRequest: on_request })
      commit(SET_MAINTENANCE_WORK, response)
    } catch (err) {
      showErrorMessage('Не удалось загрузить записи тех обслуживаний')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async fetchMaintenanceWorkById ({ commit }, id) {
    try {
      commit(TOGGLE_LOADING, true)
      return await Api.maintenance.index.getMaintenanceById(id)
    } catch (err) {
      showErrorMessage('Не удалось получить запись')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async createRequestMaintenance ({ commit, dispatch }, dto) {
    try {
      commit(TOGGLE_LOADING, true)

      const res = await Api.maintenance.index.createRequestMaintenance(dto)
      showSuccessMessage('Запись создана')
      await dispatch('fetchMaintenanceWork', { on_request: helpers.getCurrentOnReq() })
      return res?.maintenanceId
    } catch (err) {
      if (dto.onRequest) {
        showErrorMessage(err.response.data.message)
      } else {
        showErrorMessage('Не удалось создать запись')
      }
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async createMaintenanceWork ({ commit }, dto) {
    try {
      commit(TOGGLE_LOADING, true)

      const record = await createMaintenanceWork(dto)
      record.type = dto.type
      record.car_millage = dto.millage
      record.repair_sum = dto.repair_sum
      record.comment = dto.comment
      commit(ADD_MAINTENANCE_WORK, record)

      showSuccessMessage('Запись создана')
    } catch (err) {
      showErrorMessage('Не удалось создать запись')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async deleteMaintenanceWork ({ commit }, { request, comment }) {
    try {
      commit(TOGGLE_LOADING, true)
      await Api.maintenance.index.deleteMaintenance({ maintenanceId: request.maintenanceId, commentDeleted: comment })

      request.deleteTime = 'abc'
      request.commentDeleted = comment

      commit(UPDATE_MAINTENANCE_WORK, request)

      showSuccessMessage('Заявка удалена')
    } catch (err) {
      showErrorMessage('Не удалось удалить заявку')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async updateMaintenanceWork ({ commit, dispatch }, data) {
    try {
      commit(TOGGLE_LOADING, true)

      await Api.maintenance.index.updateMaintenance(data)

      showSuccessMessage('Запись создана')
      await dispatch('fetchMaintenanceWork', { on_request: helpers.getCurrentOnReq() })
    } catch (err) {
      if (data.onRequest) {
        showErrorMessage(err.response.data.message)
      } else {
        showErrorMessage('Не удалось обновить заявку')
      }

      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async acceptMaintenance ({ commit, dispatch }, data) {
    try {
      commit(TOGGLE_LOADING, true)

      await Api.maintenance.index.aceptCarMaintenance(data)
      await dispatch('fetchMaintenanceWork', { on_request: helpers.getCurrentOnReq() })
      commit(TOGGLE_LOADING, false)
    } catch (err) {
      showErrorMessage('Не удалось обновить заявку')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async toActualCarMaintenance ({ commit, dispatch }, data) {
    try {
      commit(TOGGLE_LOADING, true)

      await Api.maintenance.index.toActualCarMaintenance(data.maintenanceId)
      await dispatch('fetchMaintenanceWork', { on_request: helpers.getCurrentOnReq() })
      commit(TOGGLE_LOADING, false)
    } catch (err) {
      if (data.onRequest) {
        showErrorMessage(err.response.data.message)
      } else {
        showErrorMessage('Не удалось обновить заявку')
      }

      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },

  async compliteMaintenance ({ commit, dispatch }, id) {
    try {
      commit(TOGGLE_LOADING, true)
      await Api.maintenance.index.completeCarMaintenance(id)
      await dispatch('fetchMaintenanceWork', { on_request: helpers.getCurrentOnReq() })
      commit(TOGGLE_LOADING, false)
    } catch (err) {
      console.log(err)
      showErrorMessage('Не удалось обновить заявку')
      return Promise.reject(err)
    } finally {
      commit(TOGGLE_LOADING, false)
    }
  },
  async returnCarToOnline ({ commit, getters }, id) {
    try {
      await Api.maintenance.index.getReturnCarOnLine(id)
      // console.log(getters.setOnlineStatusCar(id))
    } catch (err) {
      showErrorMessage('Не удалось обновить заявку')
      return Promise.reject(err)
    }
  },

  setFilters ({ commit }, filters) {
    commit(SET_FILTERS, filters)
  }
}

const getters = {

  getRepairWorkById: (state) => (id) => {
    return state.repairWorks.find(x => x.id === id)
  },
  sortedDataByFilter (state) {
    return (arrProps) => {
      let { stateNumber, serviceTypeId, sortiong } = state.filters
      stateNumber = stateNumber.toLowerCase()
      // if (!stateNumber && !serviceTypeId && !sortiong) return arrProps
      if (stateNumber) {
        arrProps = arrProps.filter(e => e.carNumber.toLowerCase().indexOf(stateNumber) !== -1)
      }
      if (serviceTypeId) {
        arrProps = arrProps.filter(e => e.type === serviceTypeId)
      }
      if (sortiong === 'new') {
        arrProps = arrProps.sort((a, b) => {
          console.log(moment(a.createdAt).valueOf(), moment(b.createdAt).valueOf())
          return moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()
        })
      }
      if (sortiong === 'old') {
        arrProps = arrProps.sort((a, b) => b.createdAt.valueOf() - a.createdAt.valueOf())
      }
      return arrProps
    }
  },
  sortedDataByFilterHistory (state) {
    return (arrProps) => {
      const { stateNumber, serviceTypeId } = state.filters
      if (stateNumber) {
        arrProps = arrProps.filter(x => x.carNumber.includes(stateNumber))
      }
      if (serviceTypeId) {
        arrProps = arrProps.filter(x => x.type === serviceTypeId)
      }
      return arrProps
    }
  },
  // setOnlineStatusCar (state) {
  //   return (car_id) => {
  //     return state.maintenanceWork.filter(e => !e.offLine && !e.onRequest && !e.deleteTime && e.car_id === car_id)
  //   }s
  // },

  offlineTechInspectionRequests (state) {
    return state.maintenanceWork.filter(e => e.offLine && !e.onRequest && !e.deleteTime)
  },

  onlineTechInspectionRequests (state) {
    return state.maintenanceWork.filter(e => !e.offLine && !e.onRequest && !e.deleteTime)
  },

  deletedTechInspectionRequests (state) {
    return state.maintenanceWork.filter(e => e.deleteTime && !e.onRequest)
  },
  getMaintenanceTypesNames (state) {
    const types = state.maintenanceTypes

    // Собираем родительские типы в удобном формате
    return types.reduce((acc, type) => {
      const { maintenanceTypeId, name, alias } = type

      acc.push({
        maintenanceTypeId,
        name,
        alias
      })

      return acc
    }, [])
  },
  groupedMaintenanceTypes (state) {
    const types = state.maintenanceTypes

    // Собираем родительские типы в удобном формате
    const parentTypes = types.reduce((acc, type) => {
      if (type.parentId !== '00000000-0000-0000-0000-000000000000') return acc

      const { maintenanceTypeId, name, alias } = type

      acc[maintenanceTypeId] = {
        name,
        alias,
        children: []
      }

      return acc
    }, {})
    // Добавляем подтипы в children
    for (const index in types) {
      const type = types[index]

      if (type.parentId === '00000000-0000-0000-0000-000000000000') continue
      if (!type.parentId) continue

      parentTypes[type.parentId].children.push(type.maintenanceTypeId)
      // TODO: Избавиться от type.name
      parentTypes[type.parentId].children.push(type.name)
    }
    return parentTypes
  },

  getMaintenanceWorkByTypeIds (state) {
    return (typeIds) => {
      return state.maintenanceWork.filter(e => typeIds.includes(e.type))
    }
  },

  getMaintenanceHistoryByTypeIds (state) {
    return (typeIds, isLazyLoad = false) => {
      return state.maintenanceHistory.filter((e, index) => typeIds.includes(e.type) && (isLazyLoad ? index < 35 : true))
    }
  },

  getHistoryNameById: (state) => (id) => {
    if (state.maintenanceTypes.length === 0) return
    return state.maintenanceTypes.filter(e => e.maintenanceTypeId === id)[0]?.alias || '...'
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
